export const m = {
  login: {
    phoneLength: '11位手机号',
    code: '验证码',
    getCode: '获取验证码 ',
    login: '登录',
    serverTips: '本服务由华航提供',
    serverPhone: '华航客服热线',
    errorPhoneformat: '手机格式不正确',
    sucessSend: '发送成功',
  }, home: {
    title: 'BMW预约停车充电站',
    goTo: '到这去',
    button: '去预约',
    dataNull: '暂无开放停车场',
    ok: '确认',
    unfulfilledOrder: '您有未完成的订单，请离场后再试',
    notFromH5: '您有未完成订单，请前往MyBMW APP/即时充电小程序查看',
    tips: '尊敬的客户，宝马专属停车充电服务区-首都机场T3将于2020年4月9日起，开始按照预约页面内的收费标准进行收费，您的预约服务费将不再进行退回。超时费用也将开始正常收取。烦请您悉知此消息后，再进行预约。',
    introduction: ' 1. 本卡不记名，不挂失，遗失不补。\n 2. 本卡不可兑换现金。 \n3. 本卡需绑定微信【预约停车充电】账号，每张VIP卡只能绑定1个账户。 \n 4. 账户绑定后可更换，但更换次数不可超过3次，超过3次后VIP权益将失效。\n 5. 本卡权益可用于支付预约订单及超时订单。\n 6. VIP专属福利将不定期更新，优惠情况视当期活动详情而定。\n 7. 本卡有效期以激活后页面信息为准。\n 8. 本卡最终解释权归服务实际运营方所有。',
    introduceTitle:"VIP卡使用说明",
    introduceFooter:"实际运营商客户服务电话：",
    whcNotice:"尊敬的车主：\n       因沈阳万象城于2020年11月14日-2021年1月15日对停车场进行升级改造，在此期间BMW专属停车区暂停使用，如给您带来不便，我们深表歉意。",
    sdNotice:"尊敬的宝马车主：\n    为响应冬奥保障工作2月20日10时-2月25日0时充电桩暂停使用,但可正常停车。给您造成的不便，深感抱歉!\n2022年2月20日",
    dxNotice:"尊敬的宝马车主：\n    为了给您提供更高效更安全的充电服务，大兴机场充电桩将于2021年6月30日0时至7月1日24时进行检测维护，7月2日0时恢复。维护期间充电桩暂停使用，但可正常停车。给您造成的不便，深感抱歉！",
    xdNotice:"尊敬的宝马车主：\n    因“百年建党”活动，西单大悦城BMW专属停车充电服务区将于6月30日14：00至7月1日14：00关闭，请您提前规划出行计划。给您造成的不便，深感抱歉！",
    dfNotice:"尊敬的宝马车主：\n    因“百年建党”活动，东方广场BMW专属停车充电服务区将于6月30日13：00至7月1日24：00关闭，请您提前规划出行计划。给您造成的不便，深感抱歉！",
    hzNotice:"尊敬的宝马车主：\n    由于场地将于2021年8月4日0时起对停车场进行统一形象升级改造，杭州城西银泰城BMW专属停车充电服务区将暂停服务。场站预计恢复运营时间为2021年8月20日，给您带来的不便，我们深表歉意！",
    tjwxcNotice:"尊敬的车主：\n    由于疫情原因，天津万象城BMW专属停车充电服务区将于2022年1月11日起对暂停服务。预计恢复运营时间另行通知，给您带来的不便，我们深表歉意！\n 2022年1月11日",
    noticeTitle:"公告",
    noticeContent: "尊敬的用户：\n       BMW即时充电小程序现已登陆微信平台，请登录小程序并点击【专属充电】进行预约，现有页面仅供查看历史订单。给您带来不便，敬请谅解。",
    noticeFooter:"如需帮助，请致电:"
  }, confirmOrder: {
    title: '确认订单',
    tip: '*如车牌号不符合，工作人员将拒绝您的入场',
    carPlaceholder: '请输入车牌号',
    chargeType:"停车充电类型",
    chargetInfo1:"专属停车充电",
    chargetInfo2:"专属停车充电-直流快充",
    inTime: '预约进场时间',
    outTime: '预约离场时间',
    duration: '停车时长',
    off: '折',
    more: '更多',
    choicesTine: '常用小时',
    reservedHours: '已预约时长',
    money: '产生费用',
    hour: '小时',
    hours:'小时',
    yuan: '元',
    CNY: '元',
    accept: '同意',
    selectAgreement: '《用户协议》',
    selectpolicy: '《隐私政策》',
    bottomTop: '所有停车场都有工作人员为您提供现场服务',
    button: '提交订单',
    tipTime: "请选择预约进场时间",
    ok: '确定',
    cancel: '取消',
    errorcarNo: '车牌照格式不正确',
    today: '今天',
    tomorrow: '明天',
    secondDay:'后天',
    threeDay:'大后天',
    errorMassage: '预约进场时间不能小于当前时间',
    year:'{value} 年',
    month:'{value} 月',
    day:'{value} 日',
    tipsModel1:'专属服务区车位已满，是否预约散停车位停车',
    tipsModel2:'散停车位以停车场实际空车位为准',
    tipsModel3:'暂无空闲车位，请稍候再试',
    tipsModel4:'充电服务将产生额外费用。',
    modelCancel:'取消预约',
    modelOk:'确认预约',
    card:'会员卡'
  }, header: {
    back: "返回",
  }, parkingDuration: {
    title: '预约充电',
    topTips: "请选择停车时长",
    hours: '小时',
    hour: '小时',
    CNY: "元",
    off: '折'
  }, userCenter: {
    title: '用户中心',
    provinceName: '未绑定车牌',
    vipTitle: 'VIP会员',
    orderTitle: '订单列表',
    invoicesTitle: '开具发票',
    helpTitle: '用户帮助',
    logOut: '退出登录 ',
    logOutTitle: '确定要退出登录吗？',
    ok: '确定',
    cancel: '取消',
  }, personalData: {
    title: '个人资料',
    save: '保存',
    name: '姓名',
    gender: '性别',
    phone: '手机号',
    licenseNumber: '车牌号',
    successMeassage: '保存成功',
    male: '男',
    female: '女',
    placeholderName: '请填写姓名',
    placeholderPhone: '请填写手机号',
    placeholderCarNo: '请填写车牌号'
  }, bindingVip: {
    title: '绑定VIP',
    cardTitle: 'VIP卡号',
    save: '保存',
    binDingSuccess: '绑定成功',
    placeholdeVipNo: '请输入卡号',
  }, changeMobile: {
    title: '更改新手机号',
    phoneLength: '11位手机号',
    code: '验证码',
    getCode: '获取验证码 ',
    ok:"继续",
    cancel:'取消',
    changeWarning: '本次为第四次更换手机号, 更换成功后VIP将会失效',
    errorPhoneformat: '手机格式不正确',
    sucessSend: '发送成功',
    Updatesuccess: '保存',
    successMeassage: '保存成功',
    newAndOldPhone: '该手机号是原手机号'
  }, changeCarId: {
    title: '更改车牌号',
    nullCarNumber: '请输入车牌号',
    carFomat: '车牌照格式不正确',
    save: '保存',
    successMeassage: '保存成功',
  }, provinceList: {
    title: '请选出省份'
  }, vipInfo: {
    title: 'VIP',
    cardNumber: 'VIP卡号',
    rights: '会员权益',
    language: 'zh_CN',
  }, orderList: {
    title: '订单列表',
    rightTitle: '开发票',
    reservedInTime: '预约进场时间',
    reservedHour: '预约时长',
    reservedMoneyTitle: '预约费用',
    reservedMone: '元',
    status1: '待支付',
    status2: '待进场',
    status3: '已进场',
    status3s: '已支付',
    status4: '已取消',
    status5: '超时待支付',
    status6: '已完成',
    status7: '支付超时取消',
	status8: '未入场, 系统自动取消',
	status9: '未入场自动完成',
    extraPayStatus: '超额待付款',
    hours: '小时',
    pay: '去支付',
    nullDate: "暂无订单",
    ok: '确认',
    uncompletedTips: '当前订单未完成，请离场后再试',
  }, orderDetails: {
    title: '订单详情',
    status4: '已取消',
    status6: '已完成',
    status7: '支付超时取消',
	status8: '未入场, 系统自动取消',
	status9: '未入场自动完成',
    reservedInTime: '预约进场时间',
    reservedOutTime: '预约出场时间',
    actualInTime: '实际进场时间',
    actualOutTime: '实际出场时间',
    hoursAndMoeny: '预约停车时长与费用',
    actualPay: '实付款',
    hours: '小时',
    CNY: '元',
    refundAmount: '退款金额',
    overpayment: '超额支付',
    orderNumber: '订单号',
    complaintTitle: '我要投诉',
    invoicesTitle: '开发票',
  }, phone: {
    call: '拨打',
    serviceTitle: '联系客服',
    cancel: '取消'
  }, userHelp: {
    title: '用户帮助',
    agreementTitle: '用户协议',
    overTimeRuleClauseTitle:'超时费用规则',
    rulesTilte: '扣费规则',
    oilicyTitle:'隐私政策',
    notesInboicingTitle: '开票说明',
    commonProblemTitle:'常见问题',
    serverTitle: '联系客服 ',
    language: 'zh_CN'
  },overTimeRuleClause:{
      title:'超时费用规则',
      context1:'燃油车辆，无需支付超时停车费，现阶段为试运营期间，不限时全免；',
      context2:'新能源车辆，按照电费单价及充电电量，据实结算充电费用，多退少补。',
  }, commonProblem:{
    title:'常见问题',
    contextq1:'Q：MINI和劳斯莱斯可以享受服务吗？',
    contexta1:'A：宝马集团的MINI、劳斯莱斯车辆均可以使用该服务，同样使用前需进行线上预约，先约先得。',
    contextq2:'Q：如何进行预约？',
    contexta2:'A：关注“即时充电”微信公众号，选择充电服务后，选择预约停车充电，进入所有场站列表，根据实际情况预约相应场站即可。',
    contextq3:'Q：可以让现场工作人员保存车钥匙吗？',
    contexta3:'A：部分场站提供保存钥匙服务并提供领取凭证，详情可咨询现场工作人员。',
    contextq4:'Q：使用预约停车充电场站该注意些什么？',
    contexta4:'A：请从非ETC通道出入停车场；车辆需停在宝马停车区内；办理出场手续后，15分钟内需驶离停车场，否则，需按照机场标准付费。',
    contextq5:'Q：服务是否可以获得额外折扣？',
    contexta5:'A：BMW与服务运营方共同推出VIP卡，购买宝马新能源的客户可获得更多优惠及权益，详情请咨询经销商。'
    // contextq6:'Q：使用北京预约停车充电场站该注意些什么？',
    // contexta6:'A：请非ETC通道出入停车场；车辆需停在宝马停车区内；从入口处驶入宝马专属停车充电服务区的时间需要在30分钟内，同时从宝马专属停车服务区驶出停车场的时间在30分钟内。',
    // contextq7:'Q：限时免费停车有多久？活动结束后是否还有折扣？',
    // contexta7:'A：预计活动将持续一个月。后续BMW与实际运营方华航共同推出VIP卡，客户可获得更多优惠及权益。',
    // contextq8:'Q：除北京是否还有别的场站提供专属停车充电服务？',
    // contexta8:'A：微信公众号有目前所有开设场站信息，每个场站的运营方式及收费标准不同，详情可关注微信公众号获得更多信息。',
  },
  invoicing: {
    title: '开具发票',
    list: '开票历史'
  }, invoicesList: {
    title: '发票订单',
    status6: '已完成',
    actualInTime: '实际进场时间',
    actualInHour: '实际停车时长',
    hours: '小时',
    CNY: '元',
    nullDate: "暂无订单",
    language: 'zh_CN',
    selectAll: '全部',
    next: '下一步',
  }, invoicingInfo: {
    title: '发票详情',
    topTips: '电子发票与纸发票具有同等法律效力,可支持报销入账',
    subtitle1: '发票详情',
    subtitle2: '接收方式',
    typeTitle: '抬头类型',
    typeText1: '企业单位',
    typeText2: '个人/非企业单位',
    nameTitle: '发票抬头',
    risePlaceholder: '填写发票抬头',
    numberTitle: '税号',
    numberPlaceholder: '填写纳税认识别号',
    contextTitle: '发票内容',
    contextText: '停车服务费 ',
    contextPlaceholder: '停车服务费',
    language: 'zh_CN',
    moneyTitle: '开票金额',
    emailTilte: '电子邮件',
    tipsTrip: '用于向发送电子发票和行程单',
    emailPlaceholder: '请填写电子邮件',
    button: '提 交',
    CNY: '元',
    errorbussinssNumber: "请填写正确的企业税号",
    errorEmail: '电子邮箱格式不正确',
    tips: '请确认邮箱无误，电子发票将在系统开具后发送至您的邮箱，请注意查收邮箱',
    tips2: '您选择的发票抬头为个人抬头,如需报销,请选择公司抬头发票',
    modalTitle: '开具电子发票',
    ok: '确认提交',
    cancel: '取消',
  }, complaint: {
    title: '我要投诉',
    contextpaceholder: '请吐槽您的不满',
    button: '提 交',
    saveMessage: '保存成功'
  }, invoiceCompletion: {
    title: '开具电子发票',
    success: '提交成功 ',
    button: '开具历史'
  }, historyInvoicing: {
    title: '开票历史',
    invoiceType: '电子发票',
    context: '停车服务费',
    CNY: '元',
    statusStay: '待开票',
    statusStop: '已开票',
    dataNull: '暂无开票历史'
  }, invoiceDetails: {
    title: '发票详情',
    sonTitle1: '接受方式',
    emailTilte: '电子邮件',
    invoiceTitle: '发票抬头',
    codeTitle: '税号',
    contextTitle: '发票内容',
    feeTitle: '停车服务费',
    amountTilte: '发票金额',
    CNY: '元',
    createDate: '申请日期',
    language: 'zh_CN',
    view: '查看'
  }, invoiceExplain: {
    title: '开票说明',
    context1: '双方认可本合同项下发票为增值税普通发票，发票内容为服务费。',
    context2: '乙方如需开具发票，可在“预约充电服务”相关页面填写有效真实的发票开据信息，进入【个人中心】-【开具发票】页面，查看可开票订单并选择需要开具发票的订单，点击下一步进入【开票详情】填写开票信息，点击【提交】按钮，确认提交开票信息；',
    context3: '甲方根据乙方提交开具发票信息的请求，现场开具电子发票或将电子发票发送至乙方预留邮箱。',
  }, deductionRuler: {
    title: '扣费规则',
    tips: '每账户可享受3次订单开始后的无条件退款的权限，即订单开始后选择取消订单退款可享受全额退款。',
    tips2:'用户通过MY BMW支付的订单，取消订单时不退回支付手续费。',
    orderRuler: '取消订单的扣费规则',
    row00: '取消订单时间',
    row01: '费用退还比例',
    row02: '扣款依据',
    row10: '订单开始前30分钟(含30分钟)及以上',
    row11: '全额退款',
    row12: '暂不造成影响。',
    row20: '订单开始前30分钟内(不含30分钟)',
    row21: '退还实际支付金额的80%',
    row22: '因临时取消，至少造成了该时段1小时的资源浪费，需承担费用。',
    row30: '订单开始后',
    row31: '退还实际支付金额的50%',
    row32: '订单开始后，该车位停车资源已造成了资源浪费。',
    row40: '订单结束后',
    row41: '不予退还',
    row42: '订单完成，该车位停车资源已造成了资源浪费。',
    notesTitle: '备注:',
    li1: '如因自然灾害或场站附近（5公里范围内含5公里）道路临时封锁等不可抗力因素造成订单延误需取消订单的，一经核实，费用全额退还。',
    li2: '每账号可享受3次订单开始后的无条件退款的权限，即订单开始后选择取消订单退款，可享受全额退款。',
  },
  roadbook:{
    title:"路书"
  } ,
  submitOrder: {
    title: '订单提交成功',
    inTitle: '进场',
    tips: '请按时进场，提前如无车位需等待',
    outTitle: '离场',
    language: 'zh_CN',
    cancelButton: '取消订单',
    goPay: '去支付',
    CNY: '元',
    cancelOrderTips: '确定取消订单吗？',
    no: '暂不取消',
    yes: '确定取消',
    cancelSuccess: '取消订单成功',
    tipsTitle:'温馨提示',
    tipsConetnt:'请在停车结束后到达服务中心领取出场凭证'
  }, staySubmitOrder: {
    title: '待进场订单',
    inTitle: '进场',
    tips: '请按时进场，提前如无车位需等待',
    outTitle: '离场',
    language: 'zh_CN',
    cancelButton: '取消订单',
    goPay: '预约时支付',
    CNY: '元',
    no: '暂不取消',
    yes: '确定取消',
    cancelSuccess: '取消订单成功',
    goRuler: '取消订单扣费规则',
    confimButtom:'确认预约',
    buttonModel:'确认'
  }, excessOrder: {
    title: '超额待支付',
    inTime: '实际进场时间',
    outTime: '实际出场时间',
    dateAndMoney: '预约停车时长与费用',
    excessMoney: '超额支付',
    CNY: '元',
    goPay: '去支付',
    paySuccess: '支付成功',
  }, overtimeOrder: {
    title: '超时待支付',
    inTime: '实际进场时间',
    outTime: '实际出场时间',
    dateAndMoney: '预约停车时长与费用',
    hours: '小时',
    overTimeMoneyTitle: '超时需支付',
    chargeMoneyTitle: '预约停车充电费用',
    charge:'充电',
    overTime: '超时',
    CNY: '元',
    goPay: '去支付',
    paySuccess: '支付成功',
  }, userTreaty: {
    title: '用户协议',
    treatyTitle: '预约停车充电用户使用协议',
    agreementNo: '协议编号：',
    context1: '尊敬的用户：为了维护您的自身权益，请您在使用本服务前仔细阅读本协议及协议项下各条款，充分知悉、并了解本协议的使用规则、范围以及双方的权利、义务和责任。除非您接受本协议的所有条款，否则我司将无法为您提供该项服务。您一经点击同意/确认，即视为您已充分理解并完全接受本协议，同意本协议及项下的相关法律约束。如果您不同意本协议的任何内容或无法准确理解相关条款，请不要进行后续操作。',
    context2: '甲方：北京华航悦行网络科技有限公司',
    context3: '地址：北京市朝阳区建国路93号万达广场12号楼2307',
    context4: '客服电话：400-115-0606',
    context5: '乙方：',
    context6: '鉴于甲方推出“预约停车充电”服务，甲方愿意按照本协议规定提供预约停车充电服务，在乙方充分了解并清楚知晓本协议，双方依照中华人民共和国有关法律法规，签订本协议约定。',
    text1: '一、释义：',
    context8: '除非本协议另有规定，否则以下词语在本协议中定义如下：',
    context9: '1、甲方：北京华航悦行网络科技有限公司，“预约停车充电”服务提供商。',
    context10: '2、乙方：同意按照本协议约定使用“预约停车充电”服务的客户。',
    context11: '3、“预约停车充电”服务：是甲方推出的通过在线预约停车或停车充电车位获得的宝马专属停车充电服务。',
    text2: '二、主要内容',
    context12: '1、产品介绍：乙方根据甲方要求及本协议相关约定，至少提前30分钟通过甲方推出的“预约停车充电服务”页面进行指定停车场充电服务预约，选择进场日期、时间及停车充电时长，并支付相应费用。甲方在收到乙方预约充电订单后，对充电车位进行预留，并根据乙方需求提供停车充电服务。',
    context13: '2、合同期限：为乙方预约停车充电服务的起止时间，或自甲方为乙方提供预约停车充电服务开始起，至服务结束止。',
    text3: '三、预约停车充电服务的流程和方式',
    context14: '1、乙方在甲方推出的“预约停车充电服务”页面，选择预约停车场，预约进场时间及停车时长，确定好订单信息后，根据甲方的收费标准通过微信方式支付订单费用。',
    context15: '2、乙方按照活动页面成功预约充电停车场后，应准时自行到达预约停车场，向甲方工作人员出示订单信息，启用服务内容。甲方工作人员通过后台，核对并确认订单信息，无误后，通过后台向乙方发送订单的实际使用信息。乙方在收到甲方工作人员通过后台发送的即时信息后，开始使用服务。',
    context16: '3、如乙方因自身原因需提前进入预约场所并提前开始服务内容的，原则上最早可提前30分钟入场，否则因提前时间过久而造成出场时需与停车场场方结算额外停车费用的，甲方概不负责。',
    context17: '4、乙方应按照实际预约的停车充电时长规范停取车，如乙方因自身原因需延时结束充电服务的，则将被视为超时处理，需承担因超时所产生的相应费用及罚款。乙方在延时取车的情况下，到达预约充电停车场后，应通知甲方工作人员结束服务，甲方工作人员通过后台确认订单信息，完成订单结算，并通过后台将订单因延时而产生的额外费用发送给乙方，乙方在收到甲方的订单信息及费用支付说明后，完成超时费用结算，乙方在收到甲方工作人员通过后台发送的结束信息后，即视为订单结束。',
    context18: '5、如乙方因自身原因需提前结束充电服务的，乙方可自行前往预约充电停车场，通知甲方工作人员结束服务，甲方工作人员通过后台确认订单信息，并完成订单结算，乙方在收到甲方工作人员通过后台发送的结束信息后，即视为订单结束。甲方无需退还乙方已支付的“预约停车充电服务”费用。',
    context19: '6、订单结束后，乙方需在订单结束后的30分钟内驶离停车场所。在特殊情况下，如机场车牌识别系统升级等，甲方向乙方发放停车券，停车券将在离开宝马专属停车充电服务区30分钟后失效否则如需额外再向停车场支付费用的，甲方概不负责。',
    context20: '7、关于取消定单的退款操作说明，原则上，一经预约成功并确认费用支付后，即视为双方对交易的认可。基于交易的公平公正性，在判定乙方取消交易未对甲方车位资源产生占用浪费且不构成严重影响的前提下，如乙方需取消订单并退款的，可享受支付费用的全额退还，并不承担任何因违约而产生的相应费用。',
    context21: '8、在双方交易正式（即实际预约订单）开始前30分钟（含30分钟）通过甲方预约页面取消订单并选择费用退还的，被视为无责退款，可获得全额费用的退还。如订单开始前30分钟内（不含30分钟）通过甲方预约页面取消订单并选择费用退还的，则被视为有责退款，需承担相应的订单取消费用。原则上，订单一经开始，即视为双方对服务的认可，应不予以退款，为增强用户体验感，乙方仍可选择退款，并获得部分的费用退还。具体收退费标准，请参考本协议相关费用收取与退还说明。',
    text4: '四、费用收取及退还',
    context22: '本协议所含服务内容主要包含预约充电基础服务费收费标准和退款标准。双方同意，并按照下述条款进行费用结算：',
    context23: '1、预约充电基础服务费收费标准：预约充电基础服务费标准以H5收费为准。',
    context24: '2、取消订单费用退还规则：',
    text5: '五、甲乙双方权利及义务',
    context25: '1、甲方拥有预约充电车位的所有/使用权，及该充电车位充电桩的所有权，有义务在双方合同存续期间为乙方提供完好的充电车位及充电桩供乙方使用。',
    context26: '2、乙方确保所提供的相关证件、信息及资料真实有效合法并符合甲方要求，如因乙方所提供不实信息造成甲方经济损失或法律责任的由乙方承担相应的损失及法律责任。',
    context27: '3、甲方确保提供的充电桩符合国家标准，如因甲方提供的充电桩质量问题，造成乙方在充电过程中车辆损坏的，由甲方承担主要赔付责任，超出保险范围外的损失，乙方应协同甲方共同向充电桩制造商追责。',
    context28: '4、甲方提供的“预约停车充电服务”，是一项向乙方提供停车位及充电桩使用的服务。甲方不承担双方在合同存续期内，乙方车辆因停放甲方车位，由自身或他方原因发生交通事故或其他事故的责任，包括但不限于剐蹭、碰撞等相关车辆损毁。如因自身停车问题造成旁边车辆发生交通事故或其他事故，包括但不限于剐蹭、碰撞等相关车辆损毁，乙方应自行承担相应法律责任。若乙方车辆停放甲方车位，发生交通事故或其他事故，包括但不限于剐蹭、碰撞等车辆相关损毁，甲方作为车位及充电桩拥有/所有方，有义务协助乙方找到肇事方。',
    context29: '5、在本合同存续期间，如发生事故（包括但不限于交通意外事故、人员伤亡、车辆毁损、充电桩损坏、建筑物损坏等），甲乙双方应立刻报警、报案，并根据法定主管部门的事故认定意见承担相应责任。',
    context30: '6、若因乙方操作不当等原因，造成甲方停车场或充电桩损坏的，甲方有权要求乙方按照实际损坏的价值赔偿甲方损失。',
    text6: '六、发票开具',
    context31: '1、双方认可本合同项下发票为增值税普通发票，发票内容为服务费。',
    context32: '2、乙方如需开具发票，可在“预约充电服务”相关页面填写有效真实的发票开具信息，进入【个人中心】-【开具发票】页面，查看可开票订单并选择需要开具发票的订单，点击下一步进入【开票详情】填写开票信息，点击【提交】按钮，确认提交开票信息；',
    context33: '3、甲方根据乙方提交开具发票信息的请求，现场开具电子发票或将电子发票发送至乙方预留邮箱。',
    text7: '七、本协议的修改及终止',
    context34: '1、双方均确认，本协议的签订、生效和履行以不违反法律为前提。如果本协议中的任何一条或多条被司法部门认定为违反所须适用的法律或因为其他原因导致该条被视为无效，但该无效条款并不影响本协议其他条款的效力。',
    context35: '2、乙方同意甲方有权根据国家法律法规、市场变化等对本协议及与本协议相关的规则进行调整或者终止。',
    context36: '3、调整或修改后的协议内容及相关业务规则将在甲方的相关平台（包括但不限于官网公告、站内信、手机平台等方式）进行公布并立即生效，无需另行通知乙方。如果乙方不接受修改，可立即联甲方终止本服务；如乙方继续使用本协议的服务即被视为接受修改，并受修改后的协议及相关业务规则约束。',
    context37: '4、本协议的任何修改、补充均以甲方相关平台电子文本形式作出。',
    text8: '八、争议的解决',
    context38: '1、本协议的成立、生效、履行、解释及纠纷解决等，均适用中华人民共和国大陆地区法律。',
    context39: '2、 有关本协议之一切争议，双方应本着互惠互利的精神协商解决，如协商不成，应提交朝阳区法院诉讼解决。',
    text9: '九、生效条款',
    context40: '1、本协议以电子文本形式生成。',
    context41: '2、本协议生效：乙方按照甲方的要求，通过在活动页面上点击“微信支付”或其他成功预约并支付的按钮（具体以页面显示为准），即视为甲方与乙方已达成本协议的全部约定并同意接受本协议的全部约定和附件，以及甲方有关此活动所包含的其他与本协议有关的各项规则的规定。',
  }, addressList: {
    title: '预约停车场',
    placeholderCity: '搜索城市',
    currentCity: '当前城市',
    cancel: '取消',
    noResult: '暂无搜索结果'
  }, dataTime: {
    hours: '小时',
    hour:'小时',
    minute: '分'
  }, time: {
    inTime: '进场时间',
    duration: '预约时长',
    surplusTime: '剩余时间',
    refreshTime: '刷新时间',
    refreshSuccess: '刷新成功',
    tips: '温馨提示：出场请勿走ETC出口通道。',
    overtimeFee: '超时费用',
    CNY: '元',
    timePeriod: '超时时间',
    orderAccomplish: '订单已完成',
    overtime: '已超时'
  },oilicyPage:{
    title:'隐私政策',
    context1:'欢迎您使用本平台及服务，这表示您信赖我们对您的信息的处理方式，我们深知这项责任事关重大，因此一直致力于保护您的信息，并制定了本《隐私保护协议》，尊重和保护用户个人隐私信息是华航的基本政策，华航将使用严格的保护措施保护用户的个人隐私信息。',
    context2:'为便于您正常使用预约停车充电服务及其他本平台提供的服务，您须同意：本平台的运营商华航、本平台的知识产权所有人为华晨宝马汽车有限公司和宝马（中国）汽车贸易有限公司及其授权经销商和关联公司（包括但不限于宝马股份公司、宝马中国（服务）有限公司、宝马汽车金融（中国）有限公司、先锋国际融资租赁有限公司（以下合称为“宝马”）可依照本隐私政策分享并使用您在使用本服务的相关信息（具体范围定义如下）。',
    context3:'本隐私政策不适用于您选择通过本平台向其分享信息的任何第三方程序。运营商和宝马对该等第三方程序的保密措施或程序内容不承担任何责任。',
    context4:'在您进行注册登录、预约停车、支付费用的服务时，华航可能收集您的手机号、车牌号、地理位置、交易信息及其他您选择性提供给华航的个人信息，包括姓名和性别。您有权拒绝向华航提供这些信息。请您了解，拒绝提供手机号码、车牌号、地理位置、交易信息将导致您无法使用相关预约停车充电服务及代客泊车服务。',
    context5:'华航将会在境内运营过程中收集的您的个人信息存储于中华人民共和国境内。华航仅会在为提供华航服务之目的所必需的期间内保留您的个人信息。并且华航不会主动共享或转让您的个人信息至除宝马方外的其他方，如存在共享或转让您的个人信息的情形时我们将在征求您事先同意的情况下进行。',
    context6:'请您理解，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需先征得个人信息主体的授权同意：',
    li1:'（1）与国家安全，国家安全直接相关的；',
    li2:'（2）与公共安全，公共卫生，重大公共利益直接相关的；',
    li3:'（3）与犯罪侦查，起诉，审判和判决等直接相关的；',
    li4:'（4）出于维护个人信息主体或其他个人生命，财产等重大合法权益但又很难得到本人同意的；'
  }
}
